<template>
  <div>
    <div class="row">
      <div class="col-sm-12">
        <b-card bg-variant="light" v-if="!isClientLoading">
          <h1 class="text-left">{{ client.name }} - {{ client.address }}</h1>
          <ClientField v-if="!isClientLoading" v-for="(field, index) in fields" :key="index" :field="field" :client="client" :index="index"/>
          <hr>
          <button class="btn btn-default btn-success" @click="saveClient()">
            Save Client
            <fa v-if="isClientSaved" icon="check-circle"/>
          </button>
        </b-card>
        <hr>
      </div>
    </div>
  </div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex'
import ClientField from '@/components/ClientField'
export default {
  name: 'AdminClient',
  components: {
    ClientField
  },
  data () {
    return {
      clientObject: {}
    }
  },
  created () {
    this.loadClient(this.$route.params.id)
    this.loadFields()
  },
  methods: {
    ...mapActions(['loadClient', 'loadFields', 'saveClient'])
  },

  computed: {
    ...mapGetters(['client', 'fields', 'isClientLoading', 'isClientSaved'])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/AdminClient.vue